import { z } from 'zod';
import { CAL_EVENT_TEMPLATE_MAX_FIELDS } from '../../events/cal-event-template-max-fields.js';
import { SET_CAL_EVENT_PRODUCT_VALUES_MAX } from '../../events/set-cal-event-product-values-max.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { calEventProductValueEntryInputSchema } from './cal-event-product-value-entry-input.js';
export const setCalEventProductValuesInputSchema = z
    .object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
    values: z
        .array(calEventProductValueEntryInputSchema)
        .max(SET_CAL_EVENT_PRODUCT_VALUES_MAX, `Save at most ${SET_CAL_EVENT_PRODUCT_VALUES_MAX} values at once.`)
        .default([]),
    setBlanksToZeroForFieldKeys: z
        .array(z.string().trim().min(1, 'Field is required.').max(64, 'Invalid field.'))
        .max(CAL_EVENT_TEMPLATE_MAX_FIELDS, `Pick at most ${CAL_EVENT_TEMPLATE_MAX_FIELDS} columns.`)
        .nullish(),
})
    .refine((data) => data.values.length > 0 || (data.setBlanksToZeroForFieldKeys?.length ?? 0) > 0, 'Enter at least one value.')
    .refine((data) => new Set(data.values.map((entry) => `${entry.productId ?? entry.categoryId}:${entry.fieldKey}`)).size === data.values.length, 'Each cell can be set once per save.');
//# sourceMappingURL=set-cal-event-product-values-input.js.map